var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_127_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.329 7.28136C48.329 7.28136 61.4285 14.5454 60.9523 26.3809C60.4762 38.2164 50.5368 41.5324 51.1688 53.8441C51.1688 53.8441 52.1818 49.1861 57.671 43.8355C65.1861 36.5281 64.9004 33.6363 64.9004 33.6363C64.9004 33.6363 67.5844 56.684 80.0519 56.2078C80.0519 56.2078 73.2207 53.013 71.8268 40.5281C70.0346 24.4589 64.2684 14.5368 48.3203 7.27271L48.329 7.28136Z",
    fill: "#6AB8BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1599 52.8485C65.2878 52.8485 67.0128 51.1235 67.0128 48.9956C67.0128 46.8678 65.2878 45.1428 63.1599 45.1428C61.0321 45.1428 59.3071 46.8678 59.3071 48.9956C59.3071 51.1235 61.0321 52.8485 63.1599 52.8485Z",
    fill: "#6AB8BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3507 52.9697C11.3507 52.9697 11.2987 37.9914 21.8615 32.632C32.4243 27.2727 40.1732 34.3377 50.6148 27.7836C50.6148 27.7836 46.052 29.1775 38.71 26.987C28.6667 23.9914 26.2858 25.6537 26.2858 25.6537C26.2858 25.6537 45.091 12.0693 38.5974 1.41992C38.5974 1.41992 39.1342 8.94373 28.9178 16.2424C15.7663 25.645 9.91346 35.5238 11.3507 52.9784V52.9697Z",
    fill: "#6AB8BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5369 23.5325C42.6647 23.5325 44.3897 21.8075 44.3897 19.6797C44.3897 17.5518 42.6647 15.8268 40.5369 15.8268C38.409 15.8268 36.6841 17.5518 36.6841 19.6797C36.6841 21.8075 38.409 23.5325 40.5369 23.5325Z",
    fill: "#6AB8BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5196 62.1558C66.5196 62.1558 53.8096 70.0779 43.6884 63.9048C33.5759 57.7403 35.5153 47.4372 24.4417 42C24.4417 42 28.0261 45.1515 30.0261 52.5455C32.762 62.6667 35.42 63.8182 35.42 63.8182C35.42 63.8182 13.9741 54.961 8.3291 66.0866C8.3291 66.0866 14.4417 61.671 26.0261 66.5195C40.9352 72.7619 52.4157 72.5455 66.5109 62.1472L66.5196 62.1558Z",
    fill: "#6AB8BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8484 58.684C24.9763 58.684 26.7012 56.959 26.7012 54.8312C26.7012 52.7033 24.9763 50.9784 22.8484 50.9784C20.7206 50.9784 18.9956 52.7033 18.9956 54.8312C18.9956 56.959 20.7206 58.684 22.8484 58.684Z",
    fill: "#6AB8BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 84C18.8398 84 0 65.1602 0 42C0 18.8398 18.8398 0 42 0C65.1602 0 84 18.8398 84 42C84 65.1602 65.1602 84 42 84ZM42 5.19481C21.7056 5.19481 5.19481 21.7056 5.19481 42C5.19481 62.2944 21.7056 78.8052 42 78.8052C62.2944 78.8052 78.8052 62.2944 78.8052 42C78.8052 21.7056 62.2944 5.19481 42 5.19481Z",
    fill: "#6AB8BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_127_130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerExperience);
export default __webpack_public_path__ + "static/media/customer-experience.40042881b9d27f5f3ecddad398109071.svg";
export { ForwardRef as ReactComponent };